import CONSTANTS from "const/constants";

const { CDN_URL } = CONSTANTS;
const BASE_URL = `${CDN_URL}/static/img`;

// Images hosted on our CDN
export const ASPECT_RATIO_ICON_360 = `${BASE_URL}/aspect-ratio-icon-360.png`;
export const ASPECT_RATIO_ICON_HORIZONTAL = `${BASE_URL}/aspect-ratio-icon-horizontal.png`;
export const ASPECT_RATIO_ICON_SQUARE = `${BASE_URL}/aspect-ratio-icon-square.png`;
export const ASPECT_RATIO_ICON_VERTICAL = `${BASE_URL}/aspect-ratio-icon-vertical.png`;
export const DEFAULT_STUDIO_USER_PROFILE_IMAGE_URL = `${BASE_URL}/user-studio-default-profile-image.png`;
export const FAVICON = `${BASE_URL}/favicon.png`;
export const FAVICON_DEVELOPMENT = `${BASE_URL}/favicon-development.png`;
export const FAVICON_LOCALHOST = `${BASE_URL}/favicon-localhost.png`;
export const FAVICON_TEST = `${BASE_URL}/favicon-test.png`;
export const LOGO = `${BASE_URL}/logo.svg`;
export const LOGO_GRADIENT_PNG = `${BASE_URL}/logo-gradient.png`;

// Served from the clips directory in our CDN
export const PROCESSING_CLIP_THUMBNAIL = `${CDN_URL}/clips/grabyostudio/processing_clip_100417.gif`;

// Images served from studio
export const ANIMATED_LOADER = `/img/loader.gif`;
export const SPINNER = `/img/spinner.svg`;
export const AUDIO_THUMBNAIL = `/img/producer-audio-only-input.svg`;
export const CHEQUERED_BACKGROUND = `/img/transparency-pattern.png`;
export const NO_SHARE_HISTORY = `/img/no_share_history.svg`;
export const THUMBNAIL_AUDIO = `/img/audio-waves.svg`;
export const THUMBNAIL_NO_ASSETS = `/img/noassets2.svg`;
export const MARKER_ILLUSTRATION = `/img/marker_illustration.svg`;
export const MRSS_ILLUSTRATION = `/img/mrss_illustration.svg`;
export const NO_THUMBNAIL_IMAGE_URL = `/img/no-assets.jpg`;
export const NO_VIDEOS_ILLUSTRATION = `/img/no-videos.svg`;

// This image uses a strange bucket
export const AUDIO_THUMBNAIL_IMAGE_URL = `https://s3-eu-west-1.amazonaws.com/grabyo-sacha/media/Media-play-music-icon.png`;
